import { ContractorFormValues, ContractorMutationPayload } from '../containers';
import { RM_SAVE_FIELDS } from '../resource-types';

const TRADE_CAPACITY_MAP = [
  { toggle: 'hangerAvailable', capacity: 'hangerCapacity' },
  { toggle: 'finisherAvailable', capacity: 'finisherCapacity' },
  { toggle: 'sprayerAvailable', capacity: 'sprayerCapacity' },
  { toggle: 'trimAvailable', capacity: 'trimCapacity' },
  { toggle: 'paintAvailable', capacity: 'paintCapacity' },
  { toggle: 'bumperAvailable', capacity: 'bumperCapacity' },
] as const;

export function buildContractorPayload(
  values: ContractorFormValues,
): ContractorMutationPayload {
  const payload: ContractorMutationPayload = {
    name: values.name,
    corporation: values.corporation,
    paymentType: values.paymentType || undefined,
    paymentRate: values.paymentRate ?? undefined,
    bumperPaymentType: values.bumperPaymentType || undefined,
    bumperPaymentRate: values.bumperPaymentRate ?? undefined,
    hangerAvailable: values.hangerAvailable,
    finisherAvailable: values.finisherAvailable,
    sprayerAvailable: values.sprayerAvailable,
    trimAvailable: values.trimAvailable,
    paintAvailable: values.paintAvailable,
    bumperAvailable: values.bumperAvailable,
    specialistAvailable: values.specialistAvailable,
    active: values.active,
    suspended: values.suspended,
    canPerformHighCeilingTasks: values.canPerformHighCeilingTasks,
    notes: values.notes || undefined,
  };

  for (const { toggle, capacity } of TRADE_CAPACITY_MAP) {
    if (values[toggle]) {
      payload[capacity] = values[capacity];
    }
  }

  return payload;
}

/**
 * Regional Manager whitelist: users with only CAN_EDIT_CONTRACTOR_CAPACITY
 * may persist resource-type toggles and capacities, nothing else. Detail
 * inputs are visibly disabled, but react-hook-form still emits their
 * values — this is the authoritative server-side cut.
 */
export function buildContractorCapacityOnlyPayload(
  values: ContractorFormValues,
): ContractorMutationPayload {
  const full = buildContractorPayload(values);
  const allowed: ContractorMutationPayload = {};
  for (const field of RM_SAVE_FIELDS) {
    if (field in full) {
      (allowed as Record<string, unknown>)[field] = (
        full as Record<string, unknown>
      )[field];
    }
  }
  return allowed;
}
